(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mobxReact"), require("mobx"), require("React"), require("ReactDOM"), require("ReactRouter"), require("History"), require("weaHrmEngine"));
	else if(typeof define === 'function' && define.amd)
		define(["mobxReact", "mobx", "React", "ReactDOM", "ReactRouter", "History", "weaHrmEngine"], factory);
	else if(typeof exports === 'object')
		exports["weaHrmEngine"] = factory(require("mobxReact"), require("mobx"), require("React"), require("ReactDOM"), require("ReactRouter"), require("History"), require("weaHrmEngine"));
	else
		root["weaHrmEngine"] = factory(root["mobxReact"], root["mobx"], root["React"], root["ReactDOM"], root["ReactRouter"], root["History"], root["weaHrmEngine"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_53__, __WEBPACK_EXTERNAL_MODULE_82__, __WEBPACK_EXTERNAL_MODULE_1295__, __WEBPACK_EXTERNAL_MODULE_1297__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition